import { Component, Input } from '@angular/core';

import { SedsLoadersCoreTypeOptions } from '../../seds-loaders/seds-loaders-core/enums/seds-loaders-type-options.enum';
import { SedsLoadersCoreModeOptions } from '../../seds-loaders/seds-loaders-core/enums/seds-loaders-mode-options.enum';
import { SedsLoadersCoreModeOptionsType } from '../../seds-loaders/seds-loaders-core/types/seds-loaders-mode-options.type';

@Component({
    selector: 'seds-loaders-spinner',
    templateUrl: './seds-loaders-spinner.component.html',
    styleUrls: [],
    standalone: false
})
export class SedsLoadersSpinnerComponent {
  readonly type: SedsLoadersCoreTypeOptions = SedsLoadersCoreTypeOptions.PROGRESS_SPINNER;
  @Input()
  mode: SedsLoadersCoreModeOptionsType | SedsLoadersCoreModeOptions = SedsLoadersCoreModeOptions.INDETERMINATE;
  @Input()
  current = 0;
  @Input()
  total = 0;
}
